import { pick } from 'lodash';
import type { PostAndPatchMarkItemFields } from './types';

export function prepareMarkItemAttributes(
  markItem: PostAndPatchMarkItemFields
): MutationBodyAttributes {
  return {
    ...pick(markItem, ['submittedValue', 'inputType'])
  };
}

export function prepareMarkItemRelationships(
  markItem: PostAndPatchMarkItemFields
): MutationBodyRelationships {
  return {
    ...(markItem.testInstanceResponseMarkId
      ? {
          testInstanceResponseMark: {
            data: {
              id: `/api/v2/test-instance-response-marks/${markItem.testInstanceResponseMarkId}`,
              type: 'TestInstanceResponseMark'
            }
          }
        }
      : {}),
    ...(markItem.testInstanceResponseMarkerId
      ? {
          testInstanceResponseMarker: {
            data: {
              id: `/api/v2/test-instance-response-markers/${markItem.testInstanceResponseMarkerId}`,
              type: 'TestInstanceResponseMarker'
            }
          }
        }
      : {}),
    ...(markItem.testInstanceResponseItemId
      ? {
          testInstanceResponseItem: {
            data: {
              id: `/api/v2/test-instance-response-items/${markItem.testInstanceResponseItemId}`,
              type: 'TestInstanceResponseItem'
            }
          }
        }
      : {}),
    ...(markItem.testRubricItemId
      ? {
          testRubricItem: {
            data: {
              id: `/api/v2/test-rubric-items/${markItem.testRubricItemId}`,
              type: 'TestRubricItem'
            }
          }
        }
      : {}),
    ...(markItem.submittedOptions
      ? {
          submittedOptions: {
            data: markItem.submittedOptions?.map((testInstanceItemOptionId) => ({
              id: `/api/v2/test-rubric-item-options/${testInstanceItemOptionId}`,
              type: 'TestRubricItemOption'
            }))
          }
        }
      : {})
  };
}

export function preparePostOrPatchTestInstanceResponseMarkItem(
  markItem: PostAndPatchMarkItemFields
): PostMutationBody | PatchMutationBody {
  return {
    data: {
      type: 'TestInstanceResponseMarkItem',
      attributes: prepareMarkItemAttributes(markItem),
      relationships: prepareMarkItemRelationships(markItem)
    }
  };
}
